import React from "react";

const Chart = ({ width = 20, viewBox = "0 0 25 25", color = "#fff" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox={viewBox}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        transform="translate(1.375 1.375)"
      >
        <path
          strokeWidth="2"
          d="M1.9,0 L17.1,0 C18.1766667,0 19,1.37222222 19,3.16666667 L19,15.8333333 C19,17.6277778 18.1766667,19 17.1,19 L1.9,19 C0.823333333,19 0,17.6277778 0,15.8333333 L0,3.16666667 C0,1.37222222 0.823333333,0 1.9,0 Z"
        />
        <line
          x1="2.65"
          x2="8.35"
          y1="11.283"
          y2="11.283"
          strokeLinecap="round"
          strokeWidth="1.5"
          transform="rotate(90 5.5 11.283)"
        />
        <line
          x1="4.65"
          x2="14.35"
          y1="9.283"
          y2="9.283"
          strokeLinecap="round"
          strokeWidth="1.5"
          transform="rotate(90 9.5 9.283)"
        />
        <line
          x1="9.65"
          x2="17.35"
          y1="10.283"
          y2="10.283"
          strokeLinecap="round"
          strokeWidth="1.5"
          transform="rotate(90 13.5 10.283)"
        />
      </g>
    </svg>
  );
};

export default Chart;
